export enum DateSearchParam {
  nearestWeek = "nearestWeek",
  nearestMonth = "nearestMonth",
  nearestQuartet = "nearestQuartet",
  nearestYear = "nearestYear",
  period = "period",
  day = "day",
}

export const dateSearchParams = [
  { value: DateSearchParam.nearestWeek, name: "Najblizszy tydzień" },
  { value: DateSearchParam.nearestMonth, name: "Najblizszy miesiąc" },
  { value: DateSearchParam.nearestQuartet, name: "Najblizszy kwartał" },
  { value: DateSearchParam.nearestYear, name: "Najblizszy rok" },
  { value: DateSearchParam.period, name: "Zdefiniowany zakres dat" },
  { value: DateSearchParam.day, name: "Wybrany dzień" },
];
